import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { generatePath, useLocation, useNavigate, useParams } from 'react-router';
import { StepStatus, StepsIndicator, styles } from '@sdir/sds';
import { MspStep, getCurrentSteps } from '../../helpers/Steps';
import { useReportees } from '../../services/hooks/useReportees';

type ApplicationStepsProps = {
  disableNavigation?: boolean;
};

const ApplicationSteps: React.FC<ApplicationStepsProps> = ({ disableNavigation = false }) => {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    data: { result: reportees },
  } = useReportees();
  const { applicationUid } = useParams();

  const handleStepClick = useCallback(
    (step: MspStep) => {
      if (disableNavigation) return;
      if (step.status !== StepStatus.DISABLED) {
        const path = generatePath(step.route, { applicationUid });
        navigate(path);
      }
    },
    [applicationUid, disableNavigation, generatePath, navigate]
  );

  const steps = useMemo(() => {
    const hasReportees = !!(reportees && reportees.length > 0);
    return getCurrentSteps(location.pathname, intl, hasReportees);
  }, [intl, location?.pathname, reportees]);

  return (
    <StepsIndicator
      steps={steps}
      displayVertical
      completedChecked
      completedColor={styles.colors.secondary.green1}
      onClick={handleStepClick}
    />
  );
};

export default ApplicationSteps;
